import React from 'react';
import type { AddonsInsightsReport } from 'model/AddonsInsightsReport';
import NetSalesAddonsBarChart from './charts/NetSalesAddonsBarChart';

interface Props {
    loading: boolean;
    report: AddonsInsightsReport;
}

export const AddonsInsightsCharts: React.FC<Props> = ({ loading, report }) => {
    return (
        <NetSalesAddonsBarChart
            loading={loading}
            report={report}
        />
    );
};

export default AddonsInsightsCharts;
